import { Box } from '@mantine/core';

export const CategoryDot = ({ color }: { color: string }) => (
  <Box w={6} h={6} style={{ borderRadius: 999 }} bg={`${color}.6`} />
);
